import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { NurseriesServices } from 'v2/resources/services/nurseries';
import {
  INursery,
  IQueryModalNurseryDashboard,
  IQueryParamsNursery,
  IResponseModalNurseryDashboard,
} from 'v2/resources/types/nurseries';

export const useGetNursery = (
  params: IQueryParamsNursery,
  nameProperty: string
): UseQueryResult<Array<INursery>> => {
  return useQuery({
    queryKey: ['getNursery', params, nameProperty],
    queryFn: () => NurseriesServices.getNurseries(params),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

export const useGetNurseryModal = (
  params: IQueryModalNurseryDashboard
): UseQueryResult<IResponseModalNurseryDashboard> => {
  return useQuery({
    queryKey: ['getNurseryModal', params],
    queryFn: () => NurseriesServices.getDataNuerseryModal(params),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
